import React from "react";
import { observer } from "mobx-react-lite";
import declension from "ati-core-utils/declension";
import Button from "@components/button";
import Link from "@components/link";
import { useStore } from "../../store";
import VerificationLogo from "../../img/verification-logo.svg";
import FuelSpecialConditionLogo from "../../img/fuel-special-condition.svg";
import DoneLogo from "../../img/done-logo.svg";
import TermsBlock from "../TermsBlock/TermsBlock";
import i18nStrings from "../../strings/stings";
import { roles } from "../../const";
import { limitSeparate } from "../../utils/limitSeparate";
import interpolateReact from "../../utils/interpolateReact";
import {
  PreviewStyles,
  HeaderStyles,
  VerificationCompanyStyle,
  VerifationLogoStyle,
  FuelSpecialConditionLogoStyle,
} from "./SpecialConditionsPart.styles";

const SpecialConditionsPart = () => {
  const strings = i18nStrings;
  const { globalModule } = useStore();
  const {
    firmName,
    limit,
    role,
    hasActiveRequest,
    showAdvance,
    showSend,
    ownership,
  } = globalModule;

  const money = `${limitSeparate(limit)}\u00a0${declension(limit, strings.rubl)}`;

  const renderVerificationTerms = () => {
    if (role === roles.carrier) {
      return (
        <div className="ui-items">
          <div className="list-items"><img alt="" src={DoneLogo} /><li className="list">{strings.useWhen}</li></div>
          <div className="list-items"><img alt="" src={DoneLogo} /><li className="list">{strings.dontWait}</li></div>
          <div className="list-items"><img alt="" src={DoneLogo} /><li className="list">{strings.freeMoney}</li></div>
        </div>
      );
    }

    if (role === roles.topShipper) {
      return null;
    }

    if (role === roles.fuel) {
      return null;
    }

    return (
      <div className="ui-items">
        <div className="list-items-clolumn">
          <img alt="" src={DoneLogo} />
          <li className="list-column">{strings.forEvery}</li>
        </div>
      </div>
    );
  };

  const handleButtonClick = () => {
    if (hasActiveRequest) {
      showSend(true, "unsuccess");
    } else {
      showAdvance(true);
    }
  };

  const getTitleText = () => {
    if (role === roles.fuel) {
      return interpolateReact(strings.weAlredyCheckWithLink, [
        {
          from: "{{link}}",
          to: () => <Link className="title" onClick={handleButtonClick}>{strings.openPopupLink}</Link>,
        },
      ]);
    }
    return strings.weAlredyCheck;
  };

  const renderSubtitle = () => {
    if (role === roles.fuel) {
      return interpolateReact(strings.fuelBased, [{
        from: "{{money}}",
        to: () => (
          <span className="money">
            <b>{money}</b>
          </span>
        ),
      }]);
    }
    return interpolateReact(strings.based, [{
      from: "{{money}}",
      to: () => (
        <span className="money">
          <b>{money}</b>
        </span>
      ),
    }]);
  };

  const getButtonText = () => {
    if (role === roles.carrier) return strings.getAnnouncing;
    if (role === roles.fuel) return strings.learnDetails;

    return strings.getLine;
  };

  const renderBackGroundLogo = () => {
    if (role === roles.fuel) {
      return <FuelSpecialConditionLogoStyle alt="" src={FuelSpecialConditionLogo} />;
    }
    return <VerifationLogoStyle alt="" src={VerificationLogo} />;
  };

  return (
    <PreviewStyles>
      <HeaderStyles>
        <div>{strings.title} <br />
          <div className="company-name">{ownership} {firmName}</div>
        </div>
      </HeaderStyles>
      <div>
        <TermsBlock limit={limit} role={role} />
        <VerificationCompanyStyle>
          <div className="verification-company">
            <div className="title">
              {getTitleText()}
            </div>
            <div className="sub-title-description">
              {renderSubtitle()}
            </div>
            {renderVerificationTerms()}
            <Button className="verification-button" theme="primary" onClick={handleButtonClick}>
              {getButtonText()}
            </Button>
          </div>
          {renderBackGroundLogo()}
        </VerificationCompanyStyle>
      </div>
    </PreviewStyles>
  );
};

export default observer(SpecialConditionsPart);
